"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FallbackAppBarLogin = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ListItemButton_1 = tslib_1.__importDefault(require("@mui/material/ListItemButton"));
const ListItemText_1 = tslib_1.__importDefault(require("@mui/material/ListItemText"));
const ArgusUtils = tslib_1.__importStar(require("@mnemonic/pure-utils/ArgusUtils"));
const StyledListItem_1 = tslib_1.__importDefault(require("./StyledListItem"));
const FallbackAppBarLogin = () => (react_1.default.createElement(StyledListItem_1.default, { sx: { p: 0 } },
    react_1.default.createElement(ListItemButton_1.default, { component: "a",
        href: ArgusUtils.toSpaUrl("authentication/login") },
        react_1.default.createElement(ListItemText_1.default, { primary: "Login",
            sx: { p: 0, color: "common.white" },
            primaryTypographyProps: { variant: "button" } }))));
exports.FallbackAppBarLogin = FallbackAppBarLogin;
